<template>
  <section>
    <div class="container" v-if="agentsStrategy.length > 0">
      <!-- Vista seleccionar usuarios -->

      <div class="section__users">
        <!-- <p class="title-agents">Usuarios</p> -->
        <div class="box">
          <div class="container__search">
            <a-input
              placeholder="Busca los usuarios aquí"
              class="search__users"
              @change="handleSearchActiveUsers"
              :disabled="strategy.type_assignment === TypeAssignment.byAssignment"
            >
              <template #suffix>
                <SearchOutlined style="color: #8c8c8c" />
              </template>
            </a-input>
            <div class="container__search--select-all">
              <h3>Lista de usuarios</h3>
              <a-checkbox
                class="checkbox__select"
                @click="handleSelectAllActiveUsersStrategy(!allItemsSelected)"
                :checked="allItemsSelected"
                :indeterminate="!allItemsSelected && someItemsSelected"
                :disabled="strategy.type_assignment === TypeAssignment.byAssignment"
              >
                Seleccionar todos
              </a-checkbox>
            </div>
          </div>

          <div id="style-scroll-agente" class="scrollbar-agent">
            <div class="container-items-agent" v-if="profilesGroup">
              <div
                v-for="profileName in Object.keys(profilesGroup)"
                :key="profileName"
                class="item__agent"
              >
                <div
                  v-if="
                    profilesGroup[profileName].some((user) =>
                      user.fullname.toLowerCase().includes(searchText)
                    )
                  "
                >
                  <div class="item__agent--select-all">
                    <span class="profile__name">
                      {{ profileName }}
                    </span>
                    <a-checkbox
                      class="checkbox__select"
                      :checked="allItemsSelectedByProfile(profileName)"
                      :indeterminate="!allItemsSelectedByProfile(profileName) && thereAreItemsSelectedByProfile(profileName)"
                      @change="handleSelectActiveUsersByProfile($event, profileName)"
                      :disabled="strategy.type_assignment === TypeAssignment.byAssignment"
                    >
                      Seleccionar todos
                    </a-checkbox>
                  </div>
                </div>
                <div
                  v-for="user in orderedSubUsers(profilesGroup[profileName])"
                  :key="user.id"
                  :class="
                    user.fullname.toLowerCase().includes(searchText) === false
                      ? 'container__hide'
                      : 'container__users'
                  "
                >
                  <template
                    class="item__template"
                    v-if="user.fullname.toLowerCase().includes(searchText)"
                  >
                    <div style="display: flex">
                      <div class="container__image">
                        <div v-if="user?.picture">
                          <img class="user__icon" :src="user?.picture" alt="perfil" />
                        </div>
                        <div
                          v-else
                          :class="user?.profile_name === 'Agente' ? 'background__agent' : ''"
                          class="background__profile"
                        >
                          <img
                            v-if="user.icon"
                            class="user__profile"
                            :class="user.profile_name === 'Agente' ? 'user__agente' : ''"
                            :src="getProfileImage(user?.icon || iconDefault)"
                            alt="perfil"
                          />
                        </div>
                      </div>
                      <a-tooltip placement="top">
                        <template #title v-if="user.fullname?.length > 21">
                          <span>{{ user.fullname }}</span>
                        </template>
                        <p class="text__name">
                          {{ user.fullname }}
                        </p>
                      </a-tooltip>
                    </div>
                    <p class="text__rol">Rol: {{ profileName }}</p>
                    <a-checkbox
                      :checked="user.added"
                      @change="handleSelectSingleActiveUser($event, user.id)"
                      :disabled="strategy.type_assignment === TypeAssignment.byAssignment"
                      class="container__flex"
                    ></a-checkbox>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Vista usuarios seleccionados -->
      <!-- <div class="section__users--selected">
        <p class="title-agents">Seleccionados</p>
        <div class="box">
          <div class="container__information" v-if="!someItemsSelected">
            <img :src="squareImage" alt="empty" />
            <p class="infoUser">Aquí se visualizará los usuarios que vaya seleccionando.</p>
          </div>
          <div id="style-scroll-agente" class="scrollbar-agent">
            <div
              v-for="profileName in Object.keys(profilesGroup)"
              :key="profileName"
              class="container__selected"
            >
              <div :class="{ container__profile: user?.added }">
                <span class="profile__name" v-if="thereAreItemsSelectedByProfile(profileName)">
                  {{ profileName }}
                </span>
              </div>
              <div
                v-for="user of profilesGroup[profileName]"
                :key="user.id"
                :class="{ selectedGroup: user.added }"
              >
                <template v-if="user.added">
                  <div>
                    <a-tooltip placement="top">
                      <template #title>
                        <span v-if="user.fullname?.length > 21">{{ user.fullname }}</span>
                      </template>
                      <p class="text__name">
                        {{ user.fullname }}
                      </p>
                    </a-tooltip>
                  </div>
                  <div class="container__flex">
                    <div v-if="user?.picture">
                      <img class="user__icon" :src="user?.picture" alt="perfil" />
                    </div>
                    <div
                      v-else
                      :class="user?.profile_name === 'Agente' ? 'background__agent' : ''"
                      class="background__profile"
                    >
                      <img
                        v-if="user.icon"
                        class="user__profile"
                        :class="user.profile_name === 'Agente' ? 'user__agente' : ''"
                        :src="getProfileImage(user?.icon || iconDefault)"
                        alt="perfil"
                      />
                    </div>
                    <a
                      v-if="strategy.type_assignment !== TypeAssignment.byAssignment"
                      href="#"
                      :parent-id="user.id"
                    >
                      <CloseOutlined
                        class="icon--close"
                        @click.stop.prevent="confirmationUncheckUser($event, user.id)"
                      />
                    </a>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div v-if="agentsStrategy.length === 0">
      <div class="container-empty">
        <img :src="emptyBoxImage" class="image-empty" alt="empty" />
        <p class="text-box">
          Aquí podrás seleccionar usuarios con el permiso activado para listarse en estrategias
        </p>
        <span class="text-info"
          >Para visualizar resultados debes tener usuarios creados y asignados a alguna de tus
          campañas.
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { SearchOutlined, CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, createVNode } from "vue";
import { TypeAssignment } from "@/app/strategies/utils/enums";
import { Modal } from "ant-design-vue";

import squareImage from "@/app/entities/assets/square.svg?url";
import emptyBoxImage from "@/app/strategies/assets/empty-box.svg?url";

export default defineComponent({
  components: {
    CloseOutlined,
    SearchOutlined,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    strategy: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      TypeAssignment,
      searchText: "",
      squareImage,
      emptyBoxImage,
    };
  },
  computed: {
    getAgentSelectedStategy() {
      return this.$store.getters["getProfilesGroupStrategy"];
    },
    allItemsSelected() {
      return !Object.values(this.profilesGroup).some((profileGroup) =>
        profileGroup.some((user) => !user.added)
      );
    },
    someItemsSelected() {
      return Object.values(this.profilesGroup).some((profileGroup) =>
        profileGroup.some((user) => user.added)
      );
    },
    profilesGroup() {
      return this.$store.getters["getProfilesGroupStrategy"];
    },
    agentsStrategy() {
      return this.$store.getters["getAgentsStrategy"];
    },
    iconDefault() {
      return "smile.svg";
    },
  },
  async created() {
    await this.$store.dispatch("fetchAgentsByCampaignStrategy", this.strategy.id);
    this.$store.dispatch("fetchSelectedActiveUsersStrategy", this.strategy.users_assigned);
  },
  methods: {
    orderedSubUsers(users) {
      const selectedUusers = users
        .filter((profileName) => {
          return profileName.added;
        })
        .sort((a, b) => {
          return a.fullname?.localeCompare(b.fullname);
        });

      const subAgentsWithState1 = users
        .filter((profileName) => {
          return !profileName.added;
        })
        .sort((a, b) => {
          return a.fullname?.localeCompare(b.fullname);
        });

      return [...selectedUusers, ...subAgentsWithState1];
    },
    getProfileImage(profile) {
      return new URL(`../../../users/assets/profiles/${profile}`, import.meta.url).href;
    },
    allItemsSelectedByProfile(profileName) {
      return !this.profilesGroup[profileName].some((item) => !item.added);
    },
    thereAreItemsSelectedByProfile(profileName) {
      return this.profilesGroup[profileName]?.some((item) => item.added);
    },
    handleSearchActiveUsers(event) {
      this.searchText = event.target.value.toLowerCase();
    },
    handleSelectAllActiveUsersStrategy(checked) {
      this.$store.dispatch("selectAllActiveUsers", checked);
    },
    handleSelectActiveUsersByProfile(event, profileName) {
      this.$store.dispatch("selectActiveUsersByProfileStrategy", {
        status: event.target.checked,
        profileName,
      });
    },
    confirmationUncheckUser(event, userId) {
      /**
       * This 'if' is omitted because show the remove confirmation modal is annoying, it is not deleted
       * is case this is needed again.
       */
      // eslint-disable-next-line no-constant-condition
      if (this.strategy.users_assigned.length > 0 && false) {
        Modal.confirm({
          title: "¿Estás seguro de quitar usuarios de esta campaña? ",
          content:
            "Recuerda que también dejarán de visualizarse en las estrategias y colas asociadas a esta campaña.",
          icon: createVNode(QuestionCircleOutlined),
          okText: "Quitar",
          calcelText: "Cancelar",
          onOk: () => this.handleSelectSingleActiveUser(event, userId),
          centered: true,
        });
      } else {
        this.handleSelectSingleActiveUser(event, userId);
      }
    },
    handleSelectSingleActiveUser(event, userId) {
      this.$store.dispatch("selectSingleActiveUser", {
        status: event.target.checked,
        userId,
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  display: flex
  box-sizing: border-box
  border-radius: 2px
  justify-content: space-evenly
  .box
    background: $white
    box-sizing: border-box
    display: flex
    flex-direction: column
    height: 60vh

.container__search
  display: flex
  flex-direction: column
  margin-bottom: 10px
  &--select-all
    display: flex
    justify-content: space-between
    align-items: center
    border-bottom: 1px solid #E8E8E8
    margin-top: 15px
    width: 97%
    padding-right: 9px
    h3
      margin-bottom: 0

.item__agent
  margin-bottom: 8px
  align-items: center
  &--select-all
    display: flex
    justify-content: space-between
    padding-right: 10px
    align-items: center

.title-agents
  margin-bottom: 0px
  font-weight: 600
  color: $gray-9

.selection-agents
  width: 85%
  background: $blue-1
  border: 1px solid $blue-3
  box-sizing: border-box
  border-radius: 3px
  height: 25px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0px
  justify-content: space-between
  margin-left: 40px
  margin-top: 10px
input[type="checkbox"]
  width: 16px
  height: 16px
  margin-right: 8px
input:checked
  background-color: $blue-6
  &:hover
    background-color: $blue-6

.scrollbar-agent
  float: left
  overflow-y: scroll
  padding-right: 10px

.label-agent
  padding-left: 7px
  display: flex
  align-items: center

#style-scroll-agente::-webkit-scrollbar-track
  border-radius: 10px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar
  width: 5px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar-thumb
  border-radius: 10px
  background-color: #C4C4C4

.section__users
  margin-right: 12px
  width: 100%

.icon--close
  color: $gray-8
  margin-left: 5px

.section__users--selected
  width: 45%

.checkbox__select
  padding: 8px 0
  font-weight: 400
  display: flex
  flex-direction: row-reverse !important
  color: #00000073

.search__users
  width: 97%
  margin-top: -5px

.container__users
  display: flex
  align-items: center
  justify-content: space-between
  border: 1px solid $gray-4
  box-sizing: border-box
  border-radius: 10px
  padding: 10px
  margin-top: 10px

.container__hide
  margin-top: 10px


.profile__name
  font-weight: 600

.user__icon
  width: 26px
  height: 26px
  margin: 6px
  border-radius: 50%

.user__profile
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(62%) sepia(84%) saturate(1521%) hue-rotate(178deg) brightness(103%) contrast(99%)

.user__agente
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

.container__selected
  margin-top: 20px
  margin-left: 10px

.container__profile
  border-bottom: 1px solid #E8E8E8

.selectedGroup
  width: 85%
  background: #e6f7ff
  border: 1px solid #91d5ff
  box-sizing: border-box
  border-radius: 3px
  height: 36px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0
  justify-content: space-between
  margin-left: 40px
  margin-top: 10px
  align-items: center

.container__image
  margin-right: 10px

.container__information
  margin: 0 auto
  text-align: center
  margin-top: 90px

.infoUser
  margin-top: 40px
  color: $gray-6

.container-empty
  text-align: center
  margin-bottom: 30px

.image-empty
  padding-top: 40px
  padding-bottom: 20px
  margin-bottom: 20px
  height: 250px

.text-box
  font-size: 24px
  font-weight: 600

.text-info
  font-size: 16px

.text__name
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis
  margin-right: 4px
  width: 150px
  margin-bottom: 0
  display: flex
  align-items: center

.container__flex
  display: flex
  align-items: center

.background__profile
  background-color: rgb(230, 247, 255)
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px
  height: 32px

.background__agent
  background: #FFF6E2
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px
  height: 32px

.item__template
  display: flex
  justify-content: space-between
  border-radius: 10px
  align-items: center
  /*margin-left: 20px */
  margin-bottom: 10px
  padding: 5px 10px
  // border: 1px solid $gray-4

.text__rol
  color: $gray-6
  display: flex
  align-items: center
  margin-bottom: 0
</style>
